import React, { Component } from 'react';
import { Link } from 'react-router';

class CourseItem extends Component {
    render() {
        const { course, index } = this.props;

        return (
            <div key={ index } className="col-xs-12 col-sm-6 col-lg-4 col-xl-3 tile">
	            <div className="course-item">
		            <div className="tile-header-background">
		            </div>
		            <div className="tile-info-box tile-background-image">
			            <div className="color-mask padding-default">
				            <h4 className="h4 item-tile-title">{ course.name }</h4>
				            <div className="pos-bottom">
					            <ul className="buttons">
						            <li>
							            <Link to={`/training/courses/${ course.uid }`} type="button" className="btn btn-primary btn-block">
								            <span className="label">View course</span>
								            <span className="icon"><i className="fa fa-angle-right animated-right"/></span>
							            </Link>
						            </li>
					            </ul>
				            </div>
			            </div>
		            </div>
	            </div>
            </div>
        );
    };
}

export default CourseItem;



// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/elements/CourseItem.js